declare const ColorFresnel: any;

export class ColorFresnelModel {
  edge: [number, number, number];
  center: [number, number, number];
  centerBias: number;
  edgeBias: number;
  power: number;

  constructor(value: ColorFresnelModel = { center: [0, 0, 0], edge: [1, 1, 1], centerBias: 1, edgeBias: 0, power: 1 }) {
    const { edge, center, centerBias, edgeBias, power } = value;
    this.edge = edge;
    this.center = center;
    this.centerBias = centerBias;
    this.edgeBias = edgeBias;
    this.power = power;
  }

  /**
   * Serializes to Engine's Fresnel format
   */
  static toEngine(colorFresnel: ColorFresnelModel): (number | number[])[] {
    const { center, edge, centerBias, edgeBias, power } = colorFresnel;
    return [[...center], [...edge], centerBias, edgeBias, power];
  }
}
